<div id="button">
    <button [ngClass]="ngClass" type="button" class="btn btn-block btn-lg btn-greengo debounce" appDebounceClick (debounceClick)="onClickButton($event)" [debounceTime]="700">
        {{label}}
        <span *ngIf="timer !== -1">({{ timer }})</span>
    </button>
</div>